/* unplugin-vue-components disabled */import { render } from "./mapdecoration.vue?vue&type=template&id=52c47576&scoped=true"
import script from "./mapdecoration.vue?vue&type=script&lang=js"
export * from "./mapdecoration.vue?vue&type=script&lang=js"

import "./mapdecoration.vue?vue&type=style&index=0&id=52c47576&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c47576"]])

export default __exports__